const initialState = {
  accounts: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_EBAY_ACCOUNTS': {
      return {
        ...state,
        accounts: payload.accounts,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Accounts/Accounts.reducer.js